import {
  FETCH_COPY_DOCUMENTS_REQUEST,
  FETCH_COPY_DOCUMENTS_SUCCESS,
  FETCH_COPY_DOCUMENTS_FALUIRE,
} from './copyDocumentsTypes'

const initialState = {
  loading: false,
  copyDocumentInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_COPY_DOCUMENTS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_COPY_DOCUMENTS_SUCCESS : return {
      ...state,
      copyDocumentInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_COPY_DOCUMENTS_FALUIRE : return {
      ...state,
      loading: false,
      copyDocumentInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
